// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productListSubCategoriesStyles } from "@conklin/App/Widgets/ProductListSubCategories/ProductListSubCategories";
import { css } from "styled-components";

productListSubCategoriesStyles.container = {
    css: css`
        display: flex;
        gap: 32px 17px;
        flex-wrap: wrap;
        width: 100%;
    `,
};
productListSubCategoriesStyles.subCategoryImage = {
    width: "152px",
    height: "152px",
    mergeCss: true,
    css: css`
        img {
            object-fit: contain;
        }
    `,
};
productListSubCategoriesStyles.innerInformationContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        max-width: 152px;
    `,
};

productListSubCategoriesStyles.subCategoryNameLink = {
    css: css`
        width: 100%;
    `,
    typographyProps: {
        css: css`
            font-size: 16px;
            line-height: 19px;
            text-align: center;
            width: 100%;
        `,
    },
};
